import subMonths from 'date-fns/subMonths';
export const dateFormats = {
  time: 'HH:mm',
  shortDate: 'dd.MM.yy',
  fullDate: 'dd.MM.yyyy',
  fullDateWithTime: 'dd.MM.yyyy HH:mm',
  inputDate: 'dd MMM yyyy',
  apiDate: 'dd-MM-yyyy',
};

export const dateNewsFrom = subMonths(new Date(), 1);

export const dateNewsTo = new Date();
